import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";

import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import TouchAppIcon from "@material-ui/icons/TouchApp";

import SureDialog from "../Dialogs/SureDialog.jsx";
import FormDialog from "../Dialogs/FormDialog.jsx";

import tapBeep from "../Media/tapBeep.wav";

import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import moment from "moment";

const styles = theme => ({
  table: { maxWidth: 300 },
  deleteIcon: {
    color: theme.palette.error.dark
  },
  checkmarkIcon: {
    color: green[600]
  },
  playButton: {
    background: green[600]
  },
  tapArea: {
    background: amber[300],
    height: 200,
    fontSize: 130
  },
  tapIcon: {
    fontSize: 130
  }
});

class Tapper extends React.Component {
  constructor() {
    super();
    this.state = {
      counter: 1,
      timer: "00:00:00.0",
      startTime: 0,
      today: moment().format("YYYY-MM-DD"),
      playDisabled: false,
      results: [],
      deletedRows: [],
      tapperName: "stopwatch",
      bipSound: new Audio(tapBeep)
    };
  }

  componentDidMount = () => {
    firebase
      .database()
      .ref("raceResults/" + this.state.today)
      .once("value", snapshot => {
        if (snapshot.val()) {
          if (snapshot.val().running) {
            this.tick();
            var intervalId = setInterval(this.tick, 1);

            this.setState({
              playDisabled: true,
              startTime: snapshot.val().timerStart,
              intervalId: intervalId,
              results: snapshot.val().tapper
                ? snapshot.val().tapper.stopwatch.results
                : []
            });
          }
        }
      });
  };

  incramentCounter = () => {
    var time = this.state.timer.split(".")[0];
    var splitted = time.split(":");
    time = splitted[0] === "00" ? splitted[1] + ":" + splitted[2] : time;
    if (this.state.playDisabled) {
      this.setState(prevState => {
        prevState.results.unshift(time);
        prevState.counter += 1;
        return prevState;
      }, this.writeResults);
      this.state.bipSound.play();
    }
  };

  onDeleteRow = index => {
    this.setState(prevState => {
      prevState.deletedRows.push(index);
      return prevState;
    }, this.writeResults);
  };

  onReturnRow = index => {
    this.setState(prevState => {
      const toRemove = prevState.deletedRows.indexOf(index);
      if (toRemove !== -1) {
        prevState.deletedRows.splice(toRemove, 1);
      }
      return prevState;
    });
  };

  writeResults = () => {
    var results = {
      results: this.state.results,
      deleted: this.state.deletedRows
    };
    firebase
      .database()
      .ref(
        "raceResults/" + this.state.today + "/tapper/" + this.state.tapperName
      )
      .update(results);
  };

  tick = () => {
    this.setState({
      timer: moment(moment().valueOf() - this.state.startTime)
        .utc()
        .format("HH:mm:ss.S")
    });
  };

  componentWillUnmount = () => {
    clearInterval(this.state.intervalId);
  };

  playButtonClicked = () => {
    this.onFormDialogSubmit("stopwatch");

    // if (!this.state.tapperName) {
    // 	this.formDialog(
    // 		"Tapper Name",
    // 		"Please enter your name, please make sure that it is different if more than one device is used!"
    // 	);
    // }
  };

  stopButtonClicked = () => {
    this.sure("End Race?", "are you sure you want to invalidate the timer");
  };

  onSureAgree = () => {
    this.setState({ sureTriggered: false });
    clearInterval(this.state.intervalId);
    this.setState({
      playDisabled: false,
      today: moment().format("YYYY-MM-DD")
    });
    firebase
      .database()
      .ref("raceResults/" + this.state.today + "/running")
      .set(false);
  };

  onCloseDialog = () => {
    this.setState({ sureTriggered: false, formTriggred: false });
  };

  onFormDialogSubmit = response => {
    if (response !== "") {
      this.tick();
      var intervalId = setInterval(this.tick, 1);

      this.setState({
        playDisabled: true,
        startTime: moment().valueOf(),
        intervalId: intervalId
      });

      firebase
        .database()
        .ref("raceResults/" + this.state.today)
        .set({ timerStart: moment().valueOf(), running: true });
    }
    this.setState({ formTriggred: false, tapperName: response });
  };

  sure = (title, msg) => {
    this.setState({ sureTitle: title, sureMessage: msg, sureTriggered: true });
  };

  formDialog = (title, msg) => {
    this.setState({ formTitle: title, formMessage: msg, formTriggred: true });
  };

  render = () => {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <SureDialog
          title={this.state.sureTitle}
          message={this.state.sureMessage}
          triggered={this.state.sureTriggered}
          onAgree={this.onSureAgree}
          onDisagree={this.onCloseDialog}
        />
        <FormDialog
          title={this.state.formTitle}
          message={this.state.formMessage}
          textFieldLabel={"Your Name"}
          triggered={this.state.formTriggred}
          onSubmit={this.onFormDialogSubmit}
          onCancel={this.onCloseDialog}
        />
        <Grid container>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={2}>
                    <Button
                      variant="fab"
                      aria-label="Edit"
                      color={"secondary"}
                      onClick={this.playButtonClicked}
                      disabled={this.state.playDisabled}
                      className={classes.playButton}
                    >
                      <PlayArrowIcon />
                    </Button>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="h6" align="center">
                      {this.state.tapperName}
                    </Typography>
                    <Typography variant="h4" align="center">
                      {this.state.timer}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography align="right">
                      <Button
                        variant="fab"
                        color="secondary"
                        aria-label="Edit"
                        className={classes.button}
                        disabled={!this.state.playDisabled}
                        onClick={this.stopButtonClicked}
                      >
                        <StopIcon />
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            {this.state.playDisabled && (
              <Card>
                <CardActionArea onClick={this.incramentCounter}>
                  <Typography
                    align="center"
                    className={classes.tapArea}
                    component="div"
                  >
                    <TouchAppIcon className={classes.tapIcon} />
                  </Typography>
                </CardActionArea>
              </Card>
            )}
            <Card>
              <CardContent>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Position</TableCell>
                      <TableCell>Time</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.results.map((row, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            {this.state.results.length - index}
                          </TableCell>
                          <TableCell>{row}</TableCell>
                          <TableCell>
                            {this.state.deletedRows.indexOf(
                              this.state.results.length - index
                            ) === -1 ? (
                              <IconButton
                                className={classes.checkmarkIcon}
                                aria-label="Delete"
                                color="primary"
                                disabled={
                                  this.state.deletedRows.indexOf(
                                    this.state.results.length - index
                                  ) !== -1
                                }
                                onClick={() =>
                                  this.onDeleteRow(
                                    this.state.results.length - index
                                  )
                                }
                              >
                                <CheckIcon />
                              </IconButton>
                            ) : (
                              <IconButton
                                className={classes.deleteIcon}
                                aria-label="check"
                                color="primary"
                                onClick={() =>
                                  this.onReturnRow(
                                    this.state.results.length - index
                                  )
                                }
                              >
                                <CloseIcon />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
}

Tapper.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Tapper);
